export default __webpack_public_path__ + "static/media/29.695b63bd.jpg";